module.exports = __webpack_public_path__ + "img/share-friend.f6b3cfe3.png";